import { getAllRecords, querySnapshotToArray, firestoreDocument } from '@/services/utils/Utils.js';

import { saveRecord } from '@/services/firebase/FirestoreService.js';

import firebase from 'firebase';

export const namespaced = true;

export const state = {
  contractedRecords: [],
  subscription: null,
};

export const getters = {
  contractedRecords: ({ contractedRecords }) => contractedRecords,
  contractedRecord: (state) => (id) => state.contractedRecords.find((contractedRecord) => contractedRecord.id === id),
};

export const mutations = {
  SET_CONTRACTED_RECORDS(state, contractedRecords) {
    state.contractedRecords = contractedRecords;
  },
  SET_SUBSCRIPTION(state, subscription) {
    state.subscription = subscription;
  },
};

export const actions = {
  fetchContractedRecords({ state, commit }) {
    if (state.subscription) {
      return;
    }

    const collection = firebase.firestore().collection('contracted');
    const subscription = collection.onSnapshot((querySnapshot) => {
      commit('SET_CONTRACTED_RECORDS', querySnapshotToArray(querySnapshot));
    });

    commit('SET_SUBSCRIPTION', subscription);
  },
  saveContractedRecord(context, contractedOptions) {
    return saveRecord(contractedOptions).then((id) => id);
  },
  fetchContractedRecord({ getters }, id) {
    return new Promise((resolve, reject) => {
      if (getters.contractedRecord(id)) {
        resolve(getters.contractedRecord(id));
        return;
      }

      const contractedDocument = firestoreDocument('contracted')(id);
      contractedDocument
        .get()
        .then((querySnapshot) => {
          resolve({
            ...querySnapshot.data(),
            id: querySnapshot.id,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
